import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { paths } from "../../paths";
import { useState } from "react";
import { userProfileData } from "../../Common/profileInfo";
import { fetchQuery } from "../../functions/misc";
import { GetProfileRoles } from "../../queries/getProfileRoles";
import { GetProtectionPlanSubscription } from "../../queries/GetProtectionPlanSubscription";
import useEnrollmentStore from "../../store/EnrollmentStore";
import { useRoleStore } from "../../store/ProfileStore";
import Footer from "../footer";


const EnrollmentCompletedForm = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { setCustomerRole } = useRoleStore();
    const { setProtectionPlanEnrollment } = useEnrollmentStore();

    const onClickHandler = async () => {
        setLoading(true);
        const profileId = await userProfileData();
        const getRoles = await fetchQuery({ ProfileId: profileId }, GetProfileRoles);
        const getSubscription = await fetchQuery({ ProfileId: profileId }, GetProtectionPlanSubscription);
        if (getRoles) {
            setCustomerRole(getRoles.RoleName);
        }

        if (getSubscription) {
            setProtectionPlanEnrollment({
                subscriptionPlan: getSubscription?.ProtectionPlanName,
                subscriptionStatus: getSubscription?.Status,
                enrollmentStatus: '',
            })
        }
        setLoading(false);
        navigate(paths.dashboard.taxShield.reports);
        navigate(0);
    }
    
    
    return (
        <>
        <div className="page-container">
        <Box sx={{alignItems: 'flex-center',
            p: { xs: 2, md: 6, lg: 4 },
            m: { xs: 2, md: 6, lg: 4 }}}>
            <Box sx={{
              alignItems: 'flex-center',
              pl: { xs: 2, md: 6, lg: 4 },
              pr: { xs: 2, md: 6, lg: 4 }
            }}>
                <Typography variant="h5" sx={{mb: 2}}>{'Congratulations! You Are Enrolled'}</Typography>
                <Typography variant="body2" sx={{mb: 2}}>{'You’re now enrolled in the Optima Tax Shield. Head over to your dashboard to check out your plan and other tax tools like our IRS Notice Analyzer.'}</Typography>
                <Button
                    onClick={onClickHandler}
                    className="option-primary-button"
                >
                    Continue to Dashboard
                </Button>
            </Box>    
    </Box>
    </div>
    <Footer/>
    </>
    );
  }

  export default EnrollmentCompletedForm;
  